module.exports = __webpack_public_path__ + "static/media/v-banner-2020-6-16.ff2a56bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/v-banner-2020-6-16.jpg
// module id = 133
// module chunks = 0